// Static constants for Nokma Sani Union app

export const MAUZAS = [
  { id: 'M1', label: 'Mauza I', jakrikra: 'Jakrikra I' },
  { id: 'M2', label: 'Mauza II', jakrikra: 'Jakrikra II' },
  { id: 'M3', label: 'Mauza III', jakrikra: 'Jakrikra III' },
  { id: 'M4', label: 'Mauza IV', jakrikra: 'Jakrikra IV' },
  { id: 'OTHER', label: 'Other Mauzas', jakrikra: 'Jakrikra V' },
];

export const DOC_TYPES = [
  {
    id: 'NOC_TRADE',
    title: 'No Objection Certificate',
    subtitle: 'Trade Supplier / Hawker / Labour',
    description: 'Permission to enter and operate within an A\u2019khing (village) for trading or labour activity.',
  },
  {
    id: 'LAND',
    title: 'Land Document',
    subtitle: 'Land verification & ownership',
    description: 'Issuance of land-related documents authenticated by the Nokma Sani.',
  },
  {
    id: 'OTHER',
    title: 'Other Documents',
    subtitle: 'Custom traditional certificates',
    description: 'Any other certification falling under traditional governance authority.',
  },
];

export const STATUS_LABEL = {
  pending_jakrikra: { label: 'With Jakrikra', tone: 'amber' },
  forwarded_nokma: { label: 'Forwarded to Nokma', tone: 'blue' },
  approved: { label: 'Approved', tone: 'green' },
  rejected: { label: 'Rejected', tone: 'red' },
};

export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_sani-web-compat/artifacts/tvvpld0q_WhatsApp%20Image%202026-04-08%20at%2011.07.41%20PM%20%281%29.jpeg';
